<template>
  <div class="content">

    <el-row class="bgW">
      <el-col :span="20">
        <!--检索条件-->
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="品项名称">
            <el-input
              v-model="search.name"
              maxlength="30"
              placeholder="请输入品项名称"
            />
          </el-form-item>
          <el-form-item label="金蝶编码">
            <el-input
              v-model="search.kingdee_code"
              maxlength="30"
              placeholder="请输入金蝶编码"
            />
          </el-form-item>
          <el-form-item label="上下架状态">
            <el-select v-model="search.status" placeholder="请选择">
              <el-option
                v-for="item in options.statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
             <el-date-picker
                v-model="search.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
          </el-form-item>
          

          <el-form-item label="类目选择">
            <el-cascader
              v-model="search.type"
              :options="options.typeList"
              :props="{ checkStrictly: true }"
            />
          </el-form-item>
          <el-form-item label="认领状态" v-if=" ![1,1752, 1737, 1901, 1916, 1917].includes(userInfo.id)">
            <el-select
              v-model="search.claim_status"
              clearable
              placeholder="请选择认领状态"
            >
              <el-option
                v-for="item in options.claim_statusList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="品项权限"  v-if="userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id)">
            <el-select
              v-model="search.goods_level"
              clearable
              placeholder="请选择品项权限"
            >
              <el-option
                v-for="item in options.goods_level"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
             
          <el-form-item label="品项归属"  v-if="userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id)">
            <el-cascader
              v-model="search.shop_type"
              class="w200"
              clearable
              :options="options.shop_typeList"
              placeholder="请选择门店分类"
              :props="{
                children: 'children',
                label: 'name',
                value: 'id',
                multiple: true,
                emitPath: false
              }"
            >
            </el-cascader>
          </el-form-item>

          <el-form-item label="所属店铺" prop="shop_id"  v-if="userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id)">
            <el-select
              v-model="search.shop_id"
              clearable
              class="w200"
              multiple
              filterable
              placeholder="请选择所属店铺"
            >
              <el-option
                v-for="item in options.shop_idList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
        <el-button type="primary" size="mini" @click="getList('resetForm')">重置</el-button>
      </el-col>
    </el-row>
    <div>
      <el-button  type="primary"  size="mini" @click="getList('export')">导出数据</el-button>
      <el-button  type="primary"  size="mini" @click="goAdd" v-if="(!userInfo.is_zhiying  && [7,10].includes(userInfo.position_id) )||userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id)">新增品项</el-button>
      <el-button  type="primary"  size="mini" @click="claimGoods()" v-if="[7,10].includes(userInfo.position_id) ">一键认领品项</el-button>
      <!--列表-->
    </div>
    <div class="accountCon">
      <!--列表-->
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <ElTableColumn label="序号" type="index" width="55" />
            <ElTableColumn label="品项名称"  prop="name" />
            <ElTableColumn label="金蝶编码"  prop="kingdee_code" />
            <ElTableColumn label="所属店铺" prop="shop_name" v-if="userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id)"/>
            <ElTableColumn label="认领状态"  prop="claim_status" v-if="!userInfo.is_zhiying && ![1,1752, 1737, 1901, 1916, 1917].includes(userInfo.id)"/>
            <ElTableColumn label="适用类型"  prop="is_type_desc" v-if="userInfo.group_id == 96 ||   [1,1752, 1737, 1901, 1916, 1917].includes(userInfo.id)" />
            <ElTableColumn label="新增时间" prop="create_time" />
            <ElTableColumn label="一级类目"  prop="type_one_name" />
            <ElTableColumn label="二级类目"  prop="type_two_name" />
            <ElTableColumn label="三级类目"  prop="type_three_name" />
            <ElTableColumn label="组合人"  prop="creator_name" />
            <ElTableColumn label="组合价格"  prop="price" />
               <ElTableColumn label="状态" width="150">
              <template slot-scope="{ row }">
                <el-switch
                  v-model="row.status"
                  :active-value="1"
                  :inactive-value="2"
                  active-text="上架"
                  inactive-text="下架"
                  :disabled="!row.can_edit_status || row.claim_status == '未认领'"
                  @change="handleStatusChange(row)"
                />
              </template>
            </ElTableColumn>
            <!-- <ElTableColumn label="适用类型"  prop="create_time" /> -->
            <ElTableColumn label="操作"  fixed="right">
              <template  slot-scope="{ row }" >
                <span class="theme mr20"  @click="tapBtn('read',row)">查看</span>
                <span class="theme mr20"  @click="tapBtn('edit',row)" v-if="row.creator_id == userInfo.id || (userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id) && row.claim_status)"> 编辑</span>
                <span class="theme mr20"  @click="claimGoods(row.id)" style="color: #E6A23C;" v-if=" [7,10].includes(userInfo.position_id) && row.claim_status == '未认领'"> 认领</span>

                <!-- <span class="peril" style="color: #F56C6C;" @click="tapBtn('del',row.id)" v-if="row.creator_id == userInfo.id ||userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id)"> 删除</span> -->
              </template>  
            </ElTableColumn>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.pagesize"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import { readAdminMarketList1} from "@/api/shop";
import { getProductItem,getProductTypeParent,editProductItem,claimProductItem} from '@/api/goods';
import { convertToTreeData } from '@/utils/constants';
class Page {
  total = 0;
  page = 1;
  pagesize = 10
}
class Search {
  name = ''; 
  status = ''; 
  date = [];
  type = [];
  kingdee_code = ''; 
  shop_type = [];
  shop_id = [];
  claim_status = '';
}
class Options {
  shop_idList = [];
   shop_typeList = [
    {id: 11,name: "直营",children:[
      {id: 1,name: "门店"},
      {id: 2,name: "门诊"},
      {id: 3,name: "双美"},
    ]},
    {id: 22,name: "加盟",children:[
      {id: 4,name: "门店"},
      {id: 5,name: "门诊"},
    ]}
 ];
  typeList = []; // 类目选择
  statusList = [ // 是否禁用
    { label: '下架', value: 2 },
    { label: '上架', value: 1 }
  ];
  claim_statusList = [
    {id: 1,name: "未认领"},
    {id: 2,name: "已认领"},
  ];
  goods_level=[
    {id: 1,name: "公共商品"},
    {id: 2,name: "私有商品"},
  ];
}
export default {
  name: 'ClassifyList',
  components: {
    pagination
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),
  },
  data () {
    return {
      search: new Search(), // 检索条件
      page: new Page(), // 分页
      options: new Options(), //选项
      list: [], // 数据展示
    }
  },

  mounted () {
    this.getList();
    this.getOptionsList();
  },
  methods: {
    handleStatusChange(row){
      editProductItem({id:row.id,status:row.status} ).then(res => {
          this.$message({
            type: 'success',
            message: res.msg
          });
        this.getList('search')

      }).catch(err => {
        this.getList('search')
      })
    },
      getOptionsList(){
         getProductTypeParent({ level : 'three' }).then(res => {
            this.options.typeList  = convertToTreeData(res.data);
          })
        readAdminMarketList1({action: "shop"}).then(res => {
          this.options.shop_idList = res;
        });
    },
    goAdd () {
      this.$router.push({name:'添加品项'})
    },
    // 获取列表
    getList (option) {
     
      if(option === 'resetForm') {this.search = new Search(); this.page = new Page();}
      if(option ==='search') this.page = new Page();
      let params = {
        start : this.search.date[0] || '',
        level : this.search.type.length == 0 ? '' : this.search.type.length,  
        type_id : this.search.type[this.search.type.length-1] || '', 
        end : this.search.date[1] || '',
        name :this.search.name,
        status : this.search.status,
        kingdee_code : this.search.kingdee_code,
        shop_type : this.search.shop_type,  
        shop_id : this.search.shop_id, 
        claim_status : this.search.claim_status
      }
      if(option ==='export'){
        params = {...params,is_export:1}
        getProductItem({...params,...this.page}).then(res => {
          window.open(res.url);
        })
      }else{
        getProductItem({...params,...this.page}).then(res => {
          this.list = res.data;
          this.page.total = res.total;
        })
      }
    },
    // 点击详情
    tapBtn (type,row) {
      this.$router.push({name:'添加品项',query:{row:JSON.stringify(row),type:type}})
    },
    
    claimGoods(id){
      this.$confirm('确认认领品项吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      claimProductItem({item_id:id}).then(res => {
        this.$message({
          type: 'success',
          message: res.msg
        });
        this.getList('search')
      })
    })
  }

  }
}
</script>

<style lang="scss" scoped>

.bgW {
  background: #fff;
  border-radius: 3px;
  margin-bottom: 20px;
}
.el-form-item {
  margin: 5px  40px  3px 0 ;
}
.el-input--mini{
  width: 120px; 
}
.el-select{
  width: 120px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
  width: 200px; 
}
.el-form-item{
  margin: 5px 10px 3px 0 ;
}

.accountCon{
    background: #fff;
    padding: 10px 0px 80px;
}
</style>
